export default {
  // ── index.html / Login ──────────────────────────────
  loginPlaceholder:    "Name",
  loginBtn:            "Login with Passkey",
  loginAuthenticating: "Authenticating…",
  loginEnterName:      "Please enter a name",
  loginFailed:         "Login failed",
  // ── Display Name (Profile) ──────────────────────────
  displayNameMenuLabel:    "Display name",
  displayNameDialogTitle:  "Change display name",
  displayNameDialogDesc:   "Your display name is shown to others in chats and contacts. Your username stays the same.",
  displayNamePlaceholder:  "e.g. Anna 🌸",
  displayNameSaveBtn:      "Save",
  displayNameCancelBtn:    "Cancel",
  displayNameResetBtn:     "Reset",
  displayNameSaved:        "Display name saved",
  displayNameReset:        "Display name reset",
  displayNameTooLong:      "Display name too long (max. 32 characters).",
  displayNameInvalid:      "Invalid display name.",
  displayNameSaveFailed:   "Could not save display name.",
  displayNameRateLimit:    "Too many changes. Please wait an hour.",
  displayNameCharCount:    (n) => `${n}/32`,
  registerHandleTaken:     (handle) => `The username "${handle}" is already taken.\n\nIf it's your account: sign in with your passkey.\nOtherwise: please choose a different username.`,
  registerHandleBlocked:   (handle) => `The username "${handle}" is currently unavailable.\n\nIt was recently deleted and is blocked for 300 days. Please choose a different username.`,
  registerHandleInvalid:   "Invalid username.\n\nAllowed: 3–32 characters, only lowercase letters (a–z), digits (0–9) and underscore (_).",
  registerTooManyRequests: "Too many registration attempts. Please wait a minute and try again.",
  registerFailed:          (err) => `Registration failed: ${err}`,
  loginHandleTaken:        (handle) => `The username "${handle}" is already registered.\n\nIf it's your account: make sure your passkey is available on this device (e.g. via iCloud or Google Sync) — or use the device where you originally created the passkey.\n\nIf not: please choose a different username.`,
  loginHandleExistsConfirm:(handle) => `The username "${handle}" is already taken.\n\nIf it's your account: click OK to sign in with your passkey.\n\nIf not: click Cancel and choose a different username.`,
  loginGenericError:       (name, msg) => `Sign-in failed:\n\n${name}\n${msg}`,

  // ── inbox.html ──────────────────────────────────────
  inboxPageTitle:           "RENEX – Inbox",
  addContactHeading:        "Add contact",
  guestInviteLabel:         "Or: invite a guest (no account needed)",
  createInviteLinkBtn:      "Create invite link",
  addContactTitle:          "Add contact",
  sendRequestTitle:         "Send request",
  addContactPlaceholder:    "Username",
  addContactBtn:            "Send request",
  pendingHeading:           "Pending requests",
  contactsHeading:          "Contacts",
  deleteAccount:            "Delete account",
  logout:                   "Logout",
  langToggleLabel:          "Language",
  settings:                 "Settings",
  legalLabel:               "Legal",

  // ── Tabs ─────────────────────────────────────────────
  tabChats:             "Contacts & Chats",
  tabGroups:            "Groups",
  tabContacts:          "Contacts",
  tabVoice:             "Calls",

  // ── Voice / Calls ────────────────────────────────────
  callIncoming:         "Incoming call…",
  callRinging:          "Ringing…",
  callConnecting:       "Connecting…",
  callEnded:            "Ended",
  callMissed:           "Missed",
  voiceMitmFp:          "🚨 Security alert: audio encryption compromised (fingerprint mismatch). Call aborted.",
  voiceMitmSig:         "🚨 Security alert: caller signature invalid. Call aborted.",
  connectionDegraded:   "Connection unstable…",
  voiceErrorNoCmk:      "Encryption key with this contact is missing. Send a text message first, then try again.",
  voiceErrorBusy:       "The recipient is currently in another call.",
  voiceErrorSignaling:  "Connection to the server failed. Please try again.",
  voiceErrorIce:        "Could not establish audio connection (network/firewall).",
  voiceErrorIncompat:   "The other device is running an incompatible app version.",
  voiceErrorPermission: "Microphone permission is missing. Please allow it in your browser settings.",
  voiceErrorNoMic:      "No microphone found.",
  voiceErrorMicBusy:    "Microphone is in use by another app.",

  // ── Groups ───────────────────────────────────────────
  groupNamePlaceholder: "Group name",
  createGroupBtn:       "Create group",
  noGroups:             "No groups yet.",
  loadingText:          "Loading…",
  youSuffix:            " (You)",
  loadError:            "Failed to load",
  memberLabel:          "(Member)",
  inviteBtn:            "+ Invite",
  invitePlaceholder:    "Username…",
  alreadyMember:        (handle) => `${handle} is already a member.`,
  userNotFound:         (handle) => `User "${handle}" does not exist.`,
  notInContacts:        (handle) => `"${handle}" is not in your contacts. Add them as a contact first.`,
  inviteFailed:         "Invite failed: ",
  groupFull:            "This group is full (max. 50 members).",
  confirmRemoveMember:  (handle) => `Remove ${handle} from the group?`,
  removeMemberFailed:   "Remove failed: ",
  youWereRemoved:       "You were removed from this group.",
  leaveGroupBtn:        "Leave",
  confirmLeaveGroup:    (name) => `Leave group "${name}"?`,
  leaveFailed:          "Leave failed: ",
  createGroupFailed:    "Create group failed: ",
  groupDetails:         "Group details",
  newMessage:           "New message",
  noMessages:           "No messages yet",
  yesterday:            "Yesterday",
  youPrefix:            "You: ",
  noChatYet:            "No chat yet",

  // ── CMK-Rotation Toasts ────────────────────────────
  cmkSelfRotateToast:   "🔁 Security keys rotated ({n} chats)",
  cmkMirrorRotateToast: "🔁 Security key rotated with {peer}",
  recoveryPromptToast:  "🔐 Restore chat history — enter recovery phrase",
  // ── Recovery-Login (new device) — spec RECOVERY.md §5.3/§6.4 ──
  recoveryLoginTitle:        "Recovery via your phrase",
  recoveryLoginIntroAuth:    "You need BOTH: a passkey AND your 12-word phrase. The phrase alone isn't enough — it only decrypts your key backup. Good to know: your passkey is usually synced via iCloud Keychain or Google, so it's back on a new device once you sign in — or usable from another device via QR/Bluetooth.",
  recoveryLoginAuthBtn:      "🔐 Sign in with passkey",
  recoveryLoginPhraseTitle:  "Enter your phrase",
  recoveryLoginIntroPhrase:  "Authentication successful. Now enter your 12-word phrase to restore your keys.",
  recoveryDeriving:          "Decrypting…",
  recoveryLoginRecoverBtn:   "Restore",
  recoveryLoginDoneTitle:    "Recovery successful",
  recoveryLoginDoneIntro:    "Your keys have been decrypted:",
  recoveryStatsCmks:         "DM conversations",
  recoveryStatsGsks:         "Groups",
  recoveryLoginTodoNote:     "Your keys are restored — your existing messages are readable again on this device.",
  recoveryNotRegistered:     "Account not found. Recovery needs an existing account.",
  recoveryInvalidPhrase:     "Phrase is not valid (BIP39 error).",
  recoveryNoBundle:          "No recovery bundle found.",
  recoveryWrongPhrase:       "Incorrect.",
  attemptsLeft:              "attempts left",
  recoveryCooldown:          "Too many incorrect attempts. Try again in 1 hour.",
  recoveryVerifyFailed:      "Recovery failed",
  updateAvailableToast: "🔄 New version available — reload",

  // ── Mute / Notification-Settings ───────────────────
  mute:                 "Mute",
  muted:                "Muted",
  unmute:               "Unmute",
  muteFor:              "Mute for",
  muteUntil:            "Muted until",
  muteIndefinite:       "Muted (until you unmute)",
  mute1h:               "1 hour",
  mute8h:               "8 hours",
  mute24h:              "24 hours",
  muteForever:          "Until I turn it back on",
  muteMentionsOnly:     "Only @-mentions",
  muteMentionsAndEveryone: "@-mentions + @everyone",

  // ── Chat-Header-Menu (3-dot) ────────────────────────
  moreActions:           "More",
  removeContact:         "Remove contact",
  removeContactConfirm:  "Remove contact {peer}? Chat history stays locally.",
  removeContactSuccess:  "{peer} removed",
  contactRemovedByPeer:  "{peer} removed you from their contacts",
  contactRequestToast:   "📩 New contact request from {peer}",
  reactionToastDm:       "{emoji} {peer} reacted",
  reactionToastGroup:    "{emoji} {peer} reacted in {group}",
  captchaRequired:       "Please solve the captcha",

  // ── Invite-Link (guest invite) ─────────────────────
  inviteByLinkTitle:     "Invite via link (no account needed)",
  invite1to1Title:       "Invite someone (1:1)",
  invite1to1Hint:        "Send this link to the person you want to chat with — they join as a guest (no account needed).",
  inviteToGroupTitle:    "Invite to group: {name}",
  inviteGroupHint:       "Send this link to people you want to invite to your group — they chat as guests (no account needed).",
  creatingInvite:        "Creating invite link…",
  inviteCreateFailed:    "Could not create invite link",
  inviteCreateBtn:       "Create invite link",
  serverInviteTitle:     "Server invite link",
  serverInviteHint:      "Send this link to people with a RENEX account — it lets them join the server. Valid for 7 days.",
  inviteInvalid:         "Invite link invalid or expired",
  inviteAlreadyMember:   "You're already a member of this server",
  inviteJoinConfirm:     "Join server “{name}”? ({count} members)",
  inviteJoinSuccess:     "✅ Joined server",
  inviteJoinFailed:      "Join failed",
  inviteRateLimit:       "Too many invites — please try again later.",
  inviteShareText:       "Hi! Message me on RENEX — no account needed.",
  copy:                  "Copy",
  copied:                "Copied",
  copyFailed:            "Copy not possible — please select link manually",
  shareBtn:              "Share",
  expiresAt:             "Valid until",
  guestMsgLimit:         "Guest messages",
  convertingGuest:       "Converting guest account…",
  convertSuccess:        "Guest account claimed ✓",
  guestConvertedToast:   "👤 {old} is now {new}",
  sysGuestConvertNotice: "A guest registered an account. Previous encrypted messages remain unreadable for the other participants.",
  sysGuestExpiryWarn: "This guest access expires in {n} days. Create an account to keep your chat and keys.",
  sysGuestNowReal:       "👤 {old} is now @{new}",
  sysNowAdmin:           "👑 {user} is now Admin",
  guestJoinedToast:      "👤 {handle} joined",
  inviteAcceptedToast:   "🤝 {handle} accepted the invite",
  inviteAcceptFailed:    "Could not accept invite",
  inviteRevokeBtn:       "Revoke",
  inviteRevokeConfirm:   "Revoke this invite link? It will become invalid immediately.",
  inviteRevokeSuccess:   "Invite link revoked",
  inviteRevokeFailed:    "Could not revoke invite",
  tabInvites:            "Invites",
  invitesEmpty:          "No active invite links yet. Create one above.",
  inviteUses:            "Uses",
  inviteNeverExpires:    "never",
  inviteExpired:         "expired",
  inviteInviterLeft:     "The inviter is no longer a member of this conversation.",
  inviteByLinkLabel:     "🔗 Invite by link",

  // ── Attachments (Photo/File) ───────────────────────
  attachPhoto:             "Attach photo",
  attachFile:              "Attach file",
  attachMenuTitle:         "Add attachment",
  attachPhotoVideo:        "Photo",
  attachPhotoLibrary:      "Photo Library",
  attachTakePhoto:         "Take Photo",
  attachDocument:          "Document",
  attachGif:               "GIF",
  dropToAttach:            "Drop file to attach",
  gifNoResults:            "No results.",
  gifRateLimit:            "Too many searches — please wait.",
  gifNotConfigured:        "GIF search not available.",
  gifSearchFailed:         "GIF search failed.",
  pickGif:                 "Pick GIF",
  poweredByGiphy:          "Powered by GIPHY",

  // ── PWA Install ────────────────────────────────────
  pwaInstallTitle:         "Install as app",
  pwaInstallSub:           "Faster startup, dedicated window, always-on.",
  pwaInstallBtn:           "Install",
  pwaInstallMenuItem:      "Install as app",
  dismiss:                 "Dismiss",
  pwaIosStep1:             "Tap the Share button at the bottom of Safari",
  pwaIosStep2:             "Choose \"Add to Home Screen\" from the menu.",
  pwaIosStep3:             "Confirm with \"Add\" in the top right.",
  pwaIosVideoAlt:          "Video: installing RENEX in Safari via Share → \"Add to Home Screen\"",
  pwaMacStep1:             "In Safari, open the \"File\" menu.",
  pwaMacStep2:             "Choose \"Add to Dock…\"",
  pwaMacStep3:             "Confirm in the dialog.",
  pwaMacRequirementHint:   "Requires Safari 17 or newer (macOS Sonoma+).",
  pwaUnsupportedHint:      "Your browser doesn't support direct installation. Try Chrome, Edge, or Safari.",

  // ── Landing Hero (Statement-first) ─────────────────
  heroPrefix:             "You have a",
  heroAccent:             "pulse",
  heroLine2:              "Bots don't.",
  heroSub:                "RENEX is the messenger for humans — passkey-only, end-to-end encrypted, zero tracking. Move around: that's your pulse.",
  heroCta:                "Get started →",
  heroBack:               "← Back",
  heroKicker:             "Human communication",
  heroOpenSource:         "Open source · code on GitHub",
  showcaseTitle:          "This is RENEX",
  showcaseSub:            "A real chat — with Pulse. You don't just see words, you see that there's a human on the other side.",
  showcaseAlt:            "RENEX app — 1:1 chat with Pulse active",

  // ── Landing Marketing ──────────────────────────────
  landingSectionTitle:    "Built for humans, not for bots.",
  landingSectionSub:      "We don't prove humanity — we make automation uneconomical.",
  featurePasskeyTitle:    "🔑 Passkey-Native Login",
  featurePasskeyDesc:     "Sign in with your passkey — Face ID, Touch ID, PIN, or hardware key (YubiKey). No email, no phone, no password. Nothing that can leak.",
  featureE2eTitle:        "🔒 End-to-End Encryption",
  featureE2eDesc:         "Your messages are encrypted on your device. Not even we can read them — the server only sees ciphertext, never plaintext.",
  featureBotResistantTitle: "🤖 Bot-resistant",
  featureBotResistantDesc:  "We don't test your humanity — we just make spam too expensive. Running thousands of bots would take thousands of real devices, real biometrics, real relationships. Humans stay reachable, bots give up.",
  featureGuestTitle:      "🔗 Guest Access",
  featureGuestDesc:       "Share a link for first contact — your friend chats instantly, no signup. For lasting conversations, a passkey is created later.",
  featureCallsTitle:      "🎙️ Calls without US cloud",
  featureCallsDesc:       "Your calls run directly between devices. If that's not possible, we use our own relay server in Germany — no US cloud service, no tracker in between.",
  featureZeroTrackTitle:  "🛡️ Zero Tracking",
  featureZeroTrackDesc:   "No ads. No tracking pixels. No marketing profiles. Only technical diagnostics help us fix bugs — we can never read your message content.",
  landingFooterCopy:      "© 2026 RENEX",

  // ── Manifesto ──────────────────────────────────────
  manifestoLabel:          "Manifesto",
  landingManifestoTitle:   "Why RENEX exists",
  landingManifestoBody:    "The internet is drowning in bots, platforms sell your attention, AI imitates humans. RENEX is the counter-movement: a place by people, for people. Read what we stand for.",
  landingManifestoCta:     "Read the Manifesto →",

  // ── Pulse (Phase 6.5) ──────────────────────────────
  pulseOn:                 "Pulse on",
  pulseOff:                "Pulse off",
  pulseHintText:           "Pulse — see when someone's really there. Tap to turn it on.",
  pulsePermTitle:          "Enable Pulse",
  pulsePermBody:           "RENEX uses subtle motion of your device to make your presence visible to the other person.",
  pulsePermPoint1:         "Entirely on your device",
  pulsePermPoint2:         "Nothing is stored",
  pulsePermPoint3:         "Only the other person sees it",
  pulsePermHint:           "iOS will ask for motion permission in the next step.",
  pulsePermAllow:          "Allow →",
  pulsePresentNow:         "here right now",
  nodTooltip:              "Tap to nod 👋",

  attachmentTooLarge:      "File too large (max. 10 MB).",
  attachmentMimeBlocked:   "File type not allowed.",
  attachmentExtBlocked:    "File extension not allowed.",
  attachmentRateLimit:     "Too many uploads — please wait.",
  attachmentUploadFailed:  "Upload failed.",
  attachmentGone:          "File no longer available.",
  attachmentForbidden:     "No access to this file.",
  attachmentLoadFailed:    "Could not load file.",
  attachmentLocked:        "waiting for key",
  loadingPhoto:            "Loading photo…",
  openPhoto:               "Open photo",
  downloadBtn:             "Download",
  downloadFailed:          "Download failed.",

  // ── Device-Limit-Modal ─────────────────────────────
  deviceLimitTitle:        "Device limit reached",
  deviceLimitMessage:      "You are using {current}/{max} devices. Manage your devices under Profile → Devices and remove an old one to add this one.",
  deviceLimitOkBtn:        "Got it",

  // ── Device toasts (VISION §6 multi-device visibility) ───
  deviceAddedSelfToast:    "📱 New device added. If that wasn't you — remove it immediately under Profile → Devices.",
  deviceAddedPeerToast:    "📱 A contact added a new device.",
  deviceRevokedSelfToast:  "🔒 Device removed — keys are being rotated.",
  deviceRevokedPeerToast:  "🔒 A contact removed a device — keys rotated.",
  deviceAutoRevokedSelfToast: "🧹 Inactive device removed automatically (30 days offline).",
  deviceAutoRevokedPeerToast: "🧹 A contact's inactive device was removed automatically.",

  // ── Group inbox + Create-Modal (Phase 1C i18n) ──────
  noGroupsYet:          "No groups yet",
  members:              "members",
  createGroupTitle:     "Create group",
  groupNameHint:        "Enter a name for the group (2–50 characters).",
  selectMembersTitle:   "Select members",
  selectMembersHint:    "Choose from your contacts.",
  selectMembersHintOptional: "Choose from your contacts — optional. You can also start the group empty and invite people later.",
  noContactsCreateEmpty: "No problem — create the group empty and invite people later via invite link or 'Add members'.",
  createEmptyGroupBtn:  "Create empty group",
  selected:             "selected",
  noContactsToAdd:      "No contacts available.",
  addContactsFirst:     "Add contacts first.",
  searchContactsPlaceholder: "Search contacts…",
  noContactsMatch:      "No contacts found.",
  groupCreateFailed:    "Failed to create group",
  // ── Add-Members-Modal ──
  addBtn:               "Add",
  noContactsYet:        "You have no contacts yet.",
  alreadyMemberLabel:   "Already in",
  notInContactsHint:    "Not in your contacts?",
  inviteByLinkBtn:      "Invite by link",
  addMembersPartial:    "{ok} added, {fail} failed",
  addMembersAllFailed:  "Adding failed",
  backBtn:              "Back",

  // ── Chat menu (3-dot slide submenus) ──────────────────
  notifications:           "Notifications",
  notificationsOn:         "On",
  muteIndefiniteShort:     "∞",
  autoDeleteLabel:         "Auto-Delete",
  autoDeleteOff:           "Off",
  autoDeleteActive:        (label) => `✅ Auto-Delete active: ${label}`,
  autoDeleteDisabled:      "✅ Auto-Delete disabled",
  autoDeleteSet:           (label) => `✅ Auto-Delete: ${label}`,
  autoDeleteProposal:      (label) => `📤 Proposal sent: ${label}`,
  autoDeleteProposalIncoming: "is proposing Auto-Delete:",
  autoDeleteWaitingForPeer: "Waiting for confirmation:",
  cmkPendingBanner:        "Some messages are still encrypted. ",
  cmkPendingBannerSuffix:  "needs to come online briefly — the missing key will then load automatically.",
  cmkPendingBannerGroup:   "Some messages are still encrypted. As soon as the senders come online briefly, the missing key will load automatically.",
  autoDeleteSetByPeer:     "set Auto-Delete to:",
  autoDeleteDisabledByPeer: "disabled Auto-Delete.",
  autoDeletePending:       "Pending",
  autoDeleteDmHint:        "Both sides must agree. Proposal will be sent to the peer.",
  autoDeleteGroupHint:     "Any member can change. All members get a system message.",
  autoDeleteOneDay:        "24 hours",
  autoDeleteOneWeek:       "7 days",
  autoDeleteThirtyDays:    "30 days",
  accept:                  "Accept",
  decline:                 "Decline",
  addMembers:              "Add members",
  addMembersPrompt:        "Enter handle (e.g. anna4):",
  memberAdded:             "Member added",
  memberAddFailed:         "Failed to add member",
  renameGroup:             "Rename group",
  renameGroupPrompt:       "New group name:",
  groupRenamed:            "Group renamed",
  groupRenameFailed:       "Rename failed",
  removeMemberLabel:       "Remove member",
  removeMemberConfirm:     "Remove @{h} from the group?",
  memberRemoved:           "Member removed",
  noOtherMembers:          "No other members",
  leaveGroup:              "Leave group",
  leaveGroupConfirm:       "Really leave this group?",
  groupLeft:               "Left group",
  membersHeading:          "Members",
  groupMembersTitle:       "Members",
  groupMembersShow:        "Show members",
  roleAdmin:               "Admin",
  youSuffix:               "You",
  loadingMembers:          "Loading members…",
  loadMembersFailed:       "Failed to load members",

  // ── Chat messages ─────────────────────────────────────
  decryptPending:         "🔒 Decrypting message…",
  decryptFailed:          "🔒 Message could not be decrypted",
  decryptFailedHint:      "Encryption key unavailable — likely your or the other side re-registered.",
  decryptFailedOwn:       "🔒 You can no longer decrypt this message",
  decryptFailedOwnHint:   "The key was lost. Request a new key on a message from {peer}.",
  decryptFailedOwnGroupHint:"Your group key was lost. Older messages stay unreadable — new ones will work again.",
  decryptFailedGroupHint: "Key from {peer} is missing. Tap 'Request key' to fetch it.",
  decryptRetryBtn:        "🔄 Request new key",
  decryptRetryAgain:      "🔄 Request again",
  decryptRetrySent:       "🔁 New key requested — message may decrypt shortly",
  decryptRetryFailed:     "⚠️ Could not request key — please try again later",
  decryptRetryPending:    "⏳ Requesting…",
  decryptRetrySuccess:    "✅ Key requested",
  decryptRetrySuccessHint:"Future messages will be readable again. Older messages encrypted with lost keys cannot be recovered.",
  decryptRetryErrorBtn:   "↻ Try again",
  decryptRetryErrorHint:  "Key request failed. Check connection and try again.",
  decryptRetryPeerOfflineHint:"{peer} is currently unreachable. Ask {peer} to open the app, then try again.",
  decryptRetryPeerOfflineToast:"⚠️ {peer} unreachable",
  authorityOfflineHint:   "⚠️ {peer} is currently unreachable. Your messages will be delivered when {peer} comes back online.",
  groupMembersOfflineHint:"ℹ️ {count} member(s) currently unreachable. Your messages will be delivered when they're back online.",
  resetKeysLabel:         "🔑 Reset encryption keys",
  resetKeysConfirm:       "Reset encryption keys for this chat?\n\nThis fixes problems where messages can't be decrypted. Old messages will remain unreadable.",
  resetKeysDone:          "🔁 Keys reset — new messages will be encrypted with a fresh key",
  resetKeysFailed:        "⚠️ Could not reset keys — please try again",
  resetKeysRemote:        "🔁 The other side reset the keys — re-establishing secure session…",
  guestConvertNotice:     "🔒 Messages from your guest session cannot be displayed after registration",
  messageExpired:         "⏱ Message automatically deleted",
  deleteMessageTitle:     "Delete message",
  confirmDeleteMessage:   "Delete message?",
  statusDelivered:        "Delivered",
  statusSent:             "Sent",
  statusSending:          "Sending…",
  statusEdited:           "(edited)",
  messageDeleted:         "🗑️ Message deleted",
  noPeerKey:              "🔐 Peer has no public key yet",

  // ── Delete-Account-Dialog ───────────────────────────
  deleteAccountDialogTitle:   "Delete account",
  deleteAccountDialogBody:    "This action is irreversible. All messages and contacts will be deleted.<br><br>Enter your username to confirm:",
  deleteAccountPlaceholder:   "Your username",
  cancelBtn:                  "Cancel",
  deleteAccountConfirmBtn:    "Delete account",
  deleteAccountFailed:        "Deletion failed",
  daWipeMessages:             "All messages + attachments",
  daWipeContacts:             "All contacts (other side sees „Account deleted\")",
  daWipeGroups:                "You'll be removed from all groups",
  daWipeDevices:              "All devices logged out immediately",
  daWipePasskeys:             "All passkeys",
  daWipeBackup:               "Recovery backup on the server",
  daHandleLocked:             "Username locked for 300 days",

  // ── Footer ───────────────────────────────────────────
  footerImprint:              "Imprint",
  footerPrivacy:              "Privacy Policy",
  footerTerms:                "Terms",
  footerFeedback:             "Feedback",
  footerPress:                "Press",

  // ── Terms Consent ─────────────────────────────────────
  consentPrefix:              "I accept the",
  consentAnd:                 "and",
  consentTerms:               "Terms",
  consentPrivacy:             "Privacy Policy",
  consentSuffix:              ".",
  consentRequired:            "Please accept the Terms and Privacy Policy",

  // ── inbox.js (dynamic strings) ───────────────────────
  cryptoInitFailed:       "Cryptography could not be initialized",
  noContacts:             "No contacts yet",
  noPendingRequests:      "No pending requests",
  // ── Member-Actions-Modal ──
  openDm:                 "Direct message",
  notInContactsYet:       "Not in your contacts yet.",
  requestContactBtn:      "Request as contact",
  hasPendingRequestIn:    "wants to add you as a contact.",
  requestPendingHint:     "⏳ Request sent — waiting for confirmation.",
  cancelRequestBtn:       "Cancel request",
  guestNoActions:         "Guests cannot be added as contacts.",
  openMemberActions:      "Show actions",
  maContactAccepted:      "Contact accepted",
  maAlreadyContact:       "Already in your contacts",
  maAlreadyPending:       "Request already pending",
  maRequestSent:          "Request sent ✓",
  maRequestRejected:      "Request rejected",
  maRequestCancelled:     "Request cancelled",
  maRequestFailed:        "Request failed",
  maUserNotFound:         "User not found",
  maAccountDeleted:       "Account deleted",
  maRejectConfirm:        "Reject this request?",
  maCancelConfirm:        "Cancel request?",
  loadContactsFailed:     "Failed to load contacts",
  requestSent:            " (request sent)",
  requestWantsToConnect:  "wants to connect",
  requestWithdraw:        "Withdraw",
  acceptBtn:              "Accept",
  rejectBtn:              "Reject",
  accountDeleted:         " (account deleted)",
  removeFromList:         "Remove from list",
  handleMismatch:         "Username does not match",
  contactRequestFailed:   "Contact request failed",
  contactRequestAccountDeleted: "This account no longer exists",
  removeContactFailed:    "Could not remove contact",
  confirmRemoveContact:   (handle) => `Really remove contact ${handle}?`,
  closeBtn:               "Close",
  linkCopied:             "Link copied!",
  dmInviteSubLabel:       "DM invite (one-time)",
  linkCopiedInfo:         "Link copied — valid 48h, max. 20 messages per guest",
  linkCopiedClipboard:    (url) => `Chat with me on Renex (available 48h):\n${url}`,
  linkCopiedClipboardDm:  (url) => `Message me on Renex (available 48h, one-time link):\n${url}`,
  linkCreateFailed:       "Could not create link",
  inviteLinkCreate:       "Create invite link",
  doneBtn:                "Done",
  someInvitesFailed:      "Some invites failed:",

  // ── chat/index.html ──────────────────────────────────
  chatPageTitle:        "Chat",
  chatStartupError:    "Chat could not be loaded. Please reload the page.",
  reloadBtn:           "Reload",
  messagePlaceholder:   "Message…",
  sendBtn:              "Send",
  newMessagesSuffix:    " new messages ↓",
  replyingTo:           "Replying to",
  cancel:               "Cancel",
  editingMessage:       "Editing message",
  confirmDelete:        "Really delete this message?",
  deleteFailed:         "Delete failed",
  editFailed:           "Edit failed",
  pttToggle:            "Push-to-Talk mode",
  pttHold:              "Hold to talk (Spacebar)",
  pttSpeaking:          "Recording…",
  reconnecting:         "Reconnecting…",

  // ── chat.js (dynamic strings) ────────────────────────
  noChatPartner:      "No chat partner selected",
  chatWith:           (user) => `Chat with ${user}`,
  sendFailed:         "Message could not be sent",
  sendFailedError:    (err) => `⚠️ Send failed: ${err}`,
  unknownError:       "Unknown error",
  renameFailed:       "Rename failed: ",
  editFailed:         "Edit failed: ",
  deleteFailed:       "Delete failed: ",
  fileLabel:          "File",
  photoLabel:         "📷 Photo",
  maxLengthReached:   (max) => `Maximum ${max} characters reached`,
  charCounter:        (len, max) => `${len} / ${max} characters`,
  pleaseWait:         "Please wait a moment…",

  // ── Create Group Popup ───────────────────────────────
  createGroupLabel:    "Create group",
  nextBtn:             "Next →",
  invitePeopleLabel:   "Invite people",
  onlyContactsWarning: "Only your own contacts can be invited",
  orSeparator:         "or",
  guestInviteLinkBtn:  "🔗 Create guest invite link",
  createGroupFinish:   "Create group",
  filterPlaceholder:   "Filter…",
  noContactsFound:     "No matches",
  noContactsYet:       "No contacts yet",

  // ── Members ────────────────────────────────────────
  membersLabel:        (n) => `${n} members`,
  newGroup:            "new group",
  groupInviteToast:    (name) => `You were invited to the group "${name}"`,
  invitedByPrefix:     (by) => `From: ${by}`,

  // ── Chat Dropdown ─────────────────────────────────────
  notificationsLabel:    "Notifications",
  notificationsOn:       "On",
  notificationsOff:      "Off",
  notifAll:              "🔔 All notifications",
  notifMentionsEveryone: "@Mentions + @everyone",
  notifMentionsOnly:     "@Mentions",
  notifMuted:            "🔕 Muted",
  notifMuteFor1h:        "⏱ Mute for 1h",
  notifMuteFor8h:        "⏱ Mute for 8h",
  notifMuteFor24h:       "⏱ Mute for 24h",
  notifLevelMentions:    "@Mentions",
  notifLevelMentionsAll: "@Mentions + @all",
  notifTimedSuffix:      (time) => `Muted (${time})`,
  renameGroupLabel:      "✏️ Rename group",
  createInviteLinkLabel: "🔗 Create invite link",

  // ── Guest Banner ───────────────────────────────────────
  guestLabel:              "Guest",
  registerToAddContacts:   "Sign up to add contacts",
  guestMsgLimit:           "⚠️ Message limit reached — sign up to keep writing!",
  // GuestBanner (Session-Info im Chat-Header)
  guestSessionExpiresIn:   "Session expires in",
  guestSessionExpired:     "Guest session expired",
  guestDaysLeft:           "{n} days",
  orgInviteTitle:          "Citizen invitations (organization)",
  orgInviteHint:           "Long-lived invitations for citizens — hand over as a QR card or send by letter. One invitation = one person.",
  orgDaysLabel:            "Validity (days)",
  orgCountLabel:           "Count",
  orgLabelsLabel:          "Recipient references (optional, one per line — determines the count)",
  orgLabelsPlaceholder:    "Member Miller\nPatient 0042\n…",
  orgCreateBtn:            "Create {n} invitation(s)",
  orgCodeToggle:           "Require activation code (recipient auth)",
  orgCodeHint:             "The code is shown here ONCE — hand it over separately (second letter, phone, in person). RENEX never stores it in clear text.",
  orgCsvBtn:               "CSV",
  orgResultsTitle:         "Just created",
  orgExistingTitle:        "Existing invitations",
  orgNoInvites:            "No invitations yet.",
  orgStatusOpen:           "open",
  orgStatusConsumed:       "redeemed",
  orgStatusActive:         "active",
  orgStatusExpired:        "expired",
  orgStatusConverted:      "account created",
  inviteCitizenTitle:      "Invite citizen",
  orgBridgeHint:           "Citizens don't have a RENEX account — they don't need a handle.",
  orgBridgeBtn:            "Create invitation",
  guestMessagesLeft:       "Messages remaining",
  guestMsgLimitReached:    "Message limit reached",
  guestCreateAccount:      "Create account",
  guestJoined:         (name) => `👤 You joined as <strong>${name}</strong>`,
  expired:             "Expired",
  guestLimitReached:   "You've used all your guest messages. Create a free account with Passkey to keep reading and writing — it takes seconds, no password needed.",
  guestExpired:        "Your guest access has expired. Create a free account with Passkey to keep reading and writing — it takes seconds, no password needed.",
  guestLimitTitle:     "Message limit reached",
  guestExpiredTitle:   "Guest access expired",
  dropToSend:          "Drop file to send",
  dropUnsupported:     "Unsupported file type",
  sendCooldown:        "Sending too fast — please try again",
  timeRemaining:       "remaining",
  msgsRemaining:       "messages left",
  convertToPasskey:    "Login with Passkey",

  // ── Member List (Chat) ───────────────────────────────
  contactAdded:        "✓ Contact",
  requestContact:      "+ Request",
  requestPending:      "✓ Pending",
  requestSentConfirm:  "✓ Sent",
  errorLabel:          "✗ Error",

  // ── Misc ───────────────────────────────────────────
  cancelTitle:         "Cancel",
  networkError:        "⚠️ Network error",
  groupNameLabel:      "Group name",

  // ── GIF Modal ─────────────────────────────────────────
  gifSearchPlaceholder: "Search GIF…",
  gifTitle:             "Search GIF",
  gifSearching:         "Searching…",
  photoTitle:           "Send photo",
  fileTitle:            "Send file",

  // ── Join/Invite Page ──────────────────────────────────
  invitePageTitle:         "RENEX – Invitation",
  checkingInvite:          "Checking invitation…",
  invitedByText:           (by) => `You were invited by <strong>${by}</strong>`,
  accessFor24h:            "Access for <strong>24 hours</strong> — then save with a Passkey",
  maxMessages:             "Up to <strong>20 messages</strong> as a guest",
  e2eEncrypted:            "End-to-end encrypted",
  joinAsGuestBtn:          "Join as guest",
  loginAndJoinBtn:         "Sign in & join",
  invalidInviteTitle:      "Invalid invitation",
  inviteExpiredDefaultMsg: "This invitation link has expired or has already been used.",
  goHomeBtn:               "Go to home",
  noTokenMsg:              "This link is invalid.",
  inviteExpiredReason:     "This invitation link has expired.",
  inviteAlreadyUsed:       "This link has already been used.",
  inviteAlreadyUsedDm:     "This invitation link has already been used. Each DM link can only be used once.",
  inviteNotFound:          "This link does not exist.",
  joiningText:             "Joining…",
  captchaRequired:         "Please complete the security check first.",
  captchaFailed:           "Security check failed. Please try again.",
  joinErrorDefault:        "Error while joining.",
  successRedirecting:      "Success! Redirecting…",
  connectionError:         "Connection error",
  checkConnection:         "Please check your internet connection.",
  joinErrorTitle:          "Error joining",
  joinErrorRetry:          "Please try again.",
  networkErrorRetry:       "Network error. Please try again.",

  // ── Device Management (Multi-Device) ─────────────────
  devicesLabel:            "Devices",
  devicesTitle:            "Manage devices",
  devicesActive:           "devices active",
  devicesEmpty:            "No active devices.",
  devicesLoadFailed:       "Could not load devices",
  deviceCurrent:           "CURRENT",
  deviceUnnamed:           "Unnamed device",
  deviceLastSeen:          "last seen",
  deviceSyncing:           "syncing…",
  deviceLogoutBtn:         "Sign out",
  deviceRevokeBtn:         "Remove",
  deviceLogoutConfirm:     "End this session?",
  deviceRevokeConfirm:     "Remove device? This is permanent. All conversations will be re-encrypted with new keys.",
  deviceRevokeFailed:      "Failed to remove",
  deviceAutoRevokeHint:    "Devices are automatically removed after 30 days of inactivity.",
  addDeviceBtn:            "+ Add new device",
  addDeviceLimitTooltip:   "Limit reached. Remove a device or upgrade to Pro.",
  addDeviceTitle:          "Add new device",
  addDeviceIntro:          "Follow these steps — your Passkey stays safely on this device.",
  addDeviceStep1:          "On the new device, open renex.id.",
  addDeviceStep2:          "Enter your handle and sign in — the browser there will show a QR code.",
  addDeviceStep3:          "Scan that QR code with the camera of this device.",
  addDeviceStep4:          "Confirm with Touch-ID / Face-ID — done.",
  addDeviceConvenienceTip: "💡 Tip: scan this QR with your new device's camera to open renex.id directly (saves typing the URL).",
  addDeviceHint:           "🔒 Your Passkey stays on this device — it's never transferred. The new device creates its own Passkey, which your existing one confirms via QR scan.",
  addDeviceAppleNotice:    "✨ On Apple devices with a shared iCloud ID, a confirmation notification appears automatically instead — you can skip step 3.",
  addDeviceQrError:        "Couldn't generate QR code.",
  addDeviceCloseBtn:       "Got it",

  // ── Servers (Phase 3A) ───────────────────────────────
  serversLabel:                       "Servers",
  serversEmpty:                       "No servers yet.",
  memberSingular:                     "member",
  channelsHeading:                    "Channels",
  membersHeading:                     "Members",
  createServerBtn:                    "+ Create server",
  createServerTitle:                  "Create server",
  createServerIntro:                  "Create a hub with channels for your community.",
  createServerNameLabel:              "Name",
  createServerNamePlaceholder:        "e.g. My Clan",
  createServerDescLabel:              "Description (optional)",
  createServerDescPlaceholder:        "What's it about?",
  createServerSubmitBtn:              "Create server",
  createServerNameRequired:           "Name is required",
  createServerNameTooLong:            "Name too long (max 80 chars)",
  createServerSuccess:                "✅ Server created",
  createServerFailed:                 "Create failed",
  createServerLimitReached:           "Server limit reached (max {limit}).",
  tooManyRequests:                    "Too many requests — please wait a moment.",
  creating:                           "Creating…",
  leaveServerBtn:                     "Leave server",
  leaveServerConfirm:                 "Leave server „{name}\"?",
  leaveServerOwnerConfirm:            "You are the owner. If other members exist, you must transfer first. Try anyway?",
  leaveServerOwnerTransferRequired:   "⚠ Transfer ownership to another member first.",
  leaveServerFailed:                  "Leave failed",
  serverDeletedToast:                 "🗑 Server deleted (you were the sole owner)",
  serverLeftToast:                    "👋 Left server",
  channelSendNotReady:                "📡 Channel messages coming in Phase 4b.",

  // ── Server Settings + Role Editor (Phase 3A.5) ────────
  serverSettingsBtn:        "Server settings",
  serverSettingsTitle:      "Server settings",
  tabRoles:                 "Roles",
  tabMembers:               "Members",
  rolesReadOnly:            "👁 Read-only — you need MANAGE_ROLES to edit roles.",
  membersReadOnly:          "👁 Read-only — you need MANAGE_ROLES to change member roles.",
  tabChannels:              "Channels",
  channelsAutoDeleteReadOnly: "👁 Read-only — you need MANAGE_CHANNELS to change auto-delete.",
  channelsAutoDeleteHint:   "Auto-delete removes channel messages after the set period for all members. Everyone gets a system message.",
  // ── Phase 3A.5: General tab (server icon + name/description) ──────────
  tabGeneral:               "General",
  iconSectionTitle:         "Server icon",
  iconChooseBtn:            "Choose image",
  iconRemoveBtn:            "Remove",
  iconRemoveConfirm:        "Really remove the server icon?",
  iconHint:                 "PNG, JPEG or WebP — max 1 MB. Auto-uploads on select.",
  iconErrorMime:            "PNG, JPEG or WebP only",
  iconErrorSize:            "File too large (max 1 MB)",
  iconUploadedToast:        "✅ Server icon updated",
  iconRemovedToast:         "🗑 Server icon removed",
  iconUploadFailed:         "Icon upload failed",
  iconRemoveFailed:         "Removal failed",
  profileSectionTitle:      "Name & description",
  serverNameLabel:          "Name",
  serverDescLabel:          "Description",
  nameRequired:             "Name cannot be empty",
  serverSavedToast:         "✅ Server settings saved",
  // ── Phase 3A.5: Ban system ──────────────────────────────
  tabBanned:                "Banned",
  banBtn:                   "Ban",
  banConfirm:               "Really ban user @{handle}? They'll be removed immediately and can't return via invite.",
  banReasonPrompt:          "Reason (optional, leave empty if none):",
  bannedToast:              "🚫 @{handle} banned",
  banFailed:                "Ban failed",
  unbanBtn:                 "Unban",
  unbanConfirm:             "Lift the ban for @{handle}? They can then rejoin via invite.",
  unbannedToast:            "✅ Ban for @{handle} lifted",
  unbanFailed:              "Unban failed",
  bansEmpty:                "No active bans on this server.",
  bansHint:                 "🚫 Banned users cannot rejoin via invite. Unban lifts that.",
  bannedByLabel:            "Banned by",
  cannotBanOwner:           "Owner cannot be banned",
  cannotBanSelf:            "You can't ban yourself",
  bannedFromServerToast:    "You were banned from the server",
  // ── Phase 3A.5: Private Channels ──────────────────────
  tabPermissions:           "Permissions",
  privateBadge:             "private",
  privateChannelToggle:     "Private channel",
  privateOnHint:            "Only members with explicit access (below) see this channel. Owner + ADMINISTRATOR always see it.",
  privateOffHint:           "All server members see this channel.",
  accessListTitle:          "Who has access",
  accessEmpty:              "No one with explicit access yet — only Owner + ADMINISTRATOR see the channel.",
  addRoleSelect:            "+ Add role…",
  addMemberSelect:          "+ Add member…",
  channelName:              "Name",
  channelTopic:             "Topic",
  channelEditHint:          "Click to edit (name, topic, permissions)",
  channelSavedToast:        "✅ Channel saved",
  remove:                   "Remove",
  add:                      "Add",
  loading:                  "Loading…",
  // ── Phase 3A.5: Tier-Limits ───────────────────────────
  createServerLimitReachedFree: "Server limit reached (max {limit} as Free-tier owner). Upgrade to Pro for {proLimit}.",
  createServerLimitReachedPro:  "Server limit reached (max {limit} as Pro owner).",
  // ── Phase 5-Light: Turnstile + ServerJoinModal ────────
  joining:                  "Joining…",
  inviteJoinTitle:          "Server invitation",
  inviteJoinBtn:            "Join",
  inviteFrom:               "from @{handle}",
  inviteMemberCount:        "{count} members",
  inviteUserBanned:         "You were banned from this server and cannot join.",
  inviteServerFull:         "Server is full.",
  inviteExpired:            "Invite link expired.",
  inviteUsedUp:             "Invite link already used up.",
  roleCreateBtn:            "Create role",
  roleCreateTitle:          "Create role",
  roleEditTitle:            "Edit role",
  roleDefault:              "default",
  roleDefaultLocked:        "Default role — cannot be removed",
  roleDefaultHint:          "🛡 Default role „everyone\" — name and position are fixed. Permissions can be edited.",
  roleEdit:                 "Edit",
  roleAssign:               "Assign",
  roleRevoke:               "Revoke",
  roleNameLabel:            "Name",
  roleNamePlaceholder:      "e.g. Moderator",
  roleNameRequired:         "Name is required",
  roleNameTooLong:          "Name too long (max 64 chars)",
  roleColorLabel:           "Color",
  rolePositionLabel:        "Position",
  roleMentionableLabel:     "@-mention allowed (e.g. @Moderator)",
  roleCreated:              "✅ Role created",
  roleUpdated:              "✅ Role updated",
  roleDeleted:              "🗑 Role deleted",
  roleDeleteConfirm:        "Delete role „{name}\"?",
  owner:                    "Owner",
  permissionsHeading:       "Permissions",
  permGroupGeneral:         "General",
  permGroupModeration:      "Moderation",
  permGroupServer:          "Server management",
  permGroupVoice:           "Voice (Phase 8)",
  permGroupAdmin:           "⚠ Super-Admin",
  permViewChannel:          "View channels",
  permSendMessages:         "Send messages",
  permMentionEveryone:      "Mention @everyone",
  permManageMessages:       "Delete/pin messages",
  permKickMembers:          "Kick members",
  permBanMembers:           "Ban members (Phase 3A.5)",
  permManageChannels:       "Manage channels",
  permManageRoles:          "Manage roles",
  permManageServer:         "Change server settings",
  permInviteMembers:        "Invite members",
  permVoiceConnect:         "Join voice channel",
  permVoiceSpeak:           "Speak in voice channel",
  permAdministrator:        "ADMINISTRATOR — bypass all permission checks",
  permAdminOwnerOnly:       "owner only",
  errForbiddenManageRoles:  "No permission (MANAGE_ROLES)",
  errForbiddenRolePosition: "Position too high — you can only manage roles below your own",
  errForbiddenAdminBit:     "Only the owner can set the ADMINISTRATOR bit",
  errCannotDeleteDefault:   "Default role cannot be deleted",
  errReservedName:          "Reserved name (everyone)",
  create:                   "Create",
  save:                     "Save",
  saving:                   "Saving…",
  delete:                   "Delete",
  error:                    "Error",

  // ── Passkey Management ───────────────────────────────
  passkeysLabel:           "Passkeys",
  passkeysTitle:           "Manage Passkeys",
  passkeyAdd:              "+ Add Passkey",
  passkeyAdding:           "Creating Passkey…",
  passkeyAdded:            "Passkey added",
  passkeyAddFailed:        "Could not add Passkey",
  passkeyDelete:           "Remove",
  passkeyDeleteConfirm:    "Really remove this Passkey?",
  passkeyDeleteLast:       "Cannot remove the last Passkey",
  passkeyDeleted:          "Passkey removed",
  passkeyDeleteFailed:     "Could not remove Passkey",
  passkeyRename:           "Rename",
  passkeyRenamePlaceholder: "e.g. iPhone, MacBook…",
  passkeyRenamed:          "Passkey renamed",
  passkeyRenameFailed:     "Rename failed",
  passkeyCreated:          "Created",
  passkeyLastUsed:         "Last used",
  passkeyNeverUsed:        "Never used",
  passkeyUnnamed:          "Unnamed",
  passkeyLoadFailed:       "Could not load Passkeys",
  passkeyNamePrompt:       "Name for this Passkey (optional):",

  // ── Empty States ─────────────────────────────────────
  selectChatHint:      "Select a chat",
  noCallsYet:          "No calls yet",
  openChatForCall:     "Open a chat and tap 📞 at the top",

  // ── Locale ───────────────────────────────────────────
  locale: "en-GB",

  // ── Push Notifications ──────────────────────────────
  pushBannerTitle:      "Enable notifications",
  pushBannerSubtitle:   "Don't miss any messages",
  pushBannerActivating: "Activating…",
  pushBannerBlocked:    "Notifications blocked",

  // ── Debug / Diagnostics ─────────────────────────────
  debugLabel:  "Debug / Diagnostics",
  debugTitle:  "Debug / Diagnostics",
  debugHint:   "Tip: Lock your phone after \"Send test push\" and wait 5-10 seconds. If you see a push notification → notifications work. If not: check status above + copy result to clipboard.",

  // ── Version Update Banner ───────────────────────────
  newVersionAvailable: "New version available",
  reloadNow:           "Reload now",
  dismissBtn:          "Dismiss",
};
